export default {
  Title: 'Biên lai',
  Report: 'Báo cáo',
  CreateVoucher: 'Lập phiếu thu từ biên lai',
  ReceiptSummary: 'Bảng tổng hợp biên lai thu tiền',
  ViewReport: 'Xem tất cả báo cáo',
};
